export const OFLC_RESEND_INVITATION = 'OFLC_RESEND_INVITATION';
export const OFLC_RESEND_INVITATION_SUCCESS = 'OFLC_RESEND_INVITATION_SUCCESS';
export const OFLC_RESEND_INVITATION_FAILED = 'OFLC_RESEND_INVITATION_FAILED';

export function resendInvitation(payload) {
	return {
		type: OFLC_RESEND_INVITATION,
		payload
	};
}

export function resendInvitationSuccess(payload) {
	return {
		type: OFLC_RESEND_INVITATION_SUCCESS,
		payload: payload
	};
}

export function resendInvitationFail(payload) {
	return {
		type: OFLC_RESEND_INVITATION_FAILED,
		payload: payload
	};
}
